package br.com.htms.inspeccaocampo.shared.ui.components

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

@Composable
fun ManualDialog(onDismiss: () -> Unit) {
    CenteredAppDialog(
        onDismissRequest = onDismiss,
        title = "Manual — Procedimento",
        dismissLabel = "Fechar"
    ) {
        Text(
            modifier = Modifier
                .fillMaxWidth()
                .verticalScroll(rememberScrollState()),
            text = """
                1. Preencha os dados gerais (TST, obra, efetivo).
                2. Capture o local por GPS e informe responsável/atividade.
                3. Responda cada verificação (Sim / Não / N/A).
                4. Sim exige foto (quando configurado). Não/N/A exigem justificativa.
                5. Informe desvios e ações corretivas.
                6. Assine como Supervisor e SESMT.
                7. Salve/valide a inspeção.

                No iOS desta versão: fotos usam placeholder até a câmera nativa;
                o app Android mantém captura real, PDF e histórico.
            """.trimIndent()
        )
    }
}
